import { useQuery } from '@apollo/client';

import { type SalesCountComparisonChartFilter } from '@/app/[locale]/(authorized)/(dashboard)/components/Dashboard/components/Charts/components/SalesCountComparisonChart/components/SalesCountComparisonChartFilter';
import { type SalesVolumeComparisonChartFilter } from '@/app/[locale]/(authorized)/(dashboard)/components/Dashboard/components/Charts/components/SalesVolumeComparisonChart/components/SalesVolumeComparisonChartFilter';
import SalesPerCurrencyChart from '@/graphql/dashboard/SalesPerCurrencyChart';
import { useCommonApolloOptions } from '@/hooks/use-common-apollo-options';
import { type Defined } from '@/types/common';

import type { SalesPerCurrencyChartQuery } from '../../../../../../../../../../generated/graphql';

type UseSalesPerCurrencyChartOptions = {
  filter?: SalesVolumeComparisonChartFilter | SalesCountComparisonChartFilter;
};

export type SalesPerCurrencyChartData = Defined<SalesPerCurrencyChartQuery['dashboardWidgetsSalesPerCurrencyChartV2']>;

export function useSalesPerCurrencyChartData(options: UseSalesPerCurrencyChartOptions) {
  const { filter } = options;

  const apolloOptions = useCommonApolloOptions();

  const gateGroupId1 = filter?.gateGroups.at(0)?.id ?? '';
  const gateGroupId2 = filter?.gateGroup?.id ?? filter?.gateGroups.at(1)?.id ?? '';

  return useQuery(SalesPerCurrencyChart, {
    ...apolloOptions,
    skip: !filter || !gateGroupId1 || !gateGroupId2,
    variables:
      filter && gateGroupId1 && gateGroupId2
        ? {
            period: filter.period,
            gate_group_id_1: gateGroupId1,
            gate_group_id_2: gateGroupId2,
          }
        : undefined,
  });
}
